<template>
    <div>
        <h5 class="heading-1">
            <span>DADOS GERAIS</span>
        </h5>
        <!-- <app-k-v
            titulo="Serviço"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="comprometimento ? comprometimento.idComprometimento : ''"
        ></app-k-v> -->
        <app-k-v
            titulo="Processo"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="comprometimento ? comprometimento.processo : ''"
        ></app-k-v>
        <app-k-v
            titulo="Contrato"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="comprometimento ? comprometimento.contrato : ''"
        ></app-k-v>
        <app-k-v
            titulo="Fornecedor"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="comprometimento ? comprometimento.fornecedor : ''"
        ></app-k-v>
        <app-k-v titulo="Tipo" :md="md" :lg="lg" :xl="xl">
            <app-status
                :status="
                    comprometimento && comprometimento.tipo
                        ? comprometimento.tipo
                        : ''
                "
            ></app-status>
        </app-k-v>
        <app-k-v
            titulo="Histórico"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="comprometimento ? comprometimento.historico : ''"
        ></app-k-v>
        <app-k-v titulo="Valor" :md="md" :lg="lg" :xl="xl">
            <strong>{{ comprometimento.valor | currency }}</strong>
        </app-k-v>
        <app-k-v
            titulo="ID RM"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="comprometimento ? comprometimento.idRm : ''"
        ></app-k-v>
    </div>
</template>

<script>
export default {
    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            md: 2,
            lg: 2,
            xl: 2
        }
    }
}
</script>
